import { render, staticRenderFns } from "./ListMsg.vue?vue&type=template&id=ac00de00&"
import script from "./ListMsg.vue?vue&type=script&lang=js&"
export * from "./ListMsg.vue?vue&type=script&lang=js&"
import style0 from "./ListMsg.vue?vue&type=style&index=0&id=ac00de00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports